import { useQuery } from "react-query";
import { getApprovedInvoiceCount } from "../../../../../actions/CarrierAgreementMgmt/VendorInvoice";

const useGetApprovedInvoiceCount = () => {
  return useQuery("GetApprovedInvoiceCount", getApprovedInvoiceCount, {
    refetchOnWindowFocus: false,
  });
};

export default useGetApprovedInvoiceCount;
